import { createSlice } from '@reduxjs/toolkit';

export const clientsSlice = createSlice({
    name: "clients",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const clientsActions = clientsSlice.actions;

export default clientsSlice.reducer;